function randomString(len, charSet) {
    var randomString = ''
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length)
        randomString += charSet.substring(randomPoz, randomPoz + 1)
    }
    return randomString
}

const scenarioRecherche = {
    autres_contacts_banque_solicite_1: 'BNP',
    autres_contacts_banque_solicite_2: ['sg', 'ca', 'bnp'],
    autres_contacts_courtier_solicite: '',
    contact_mail:
        randomString(8, 'abcdefghijklmnopqrstuvwxyz0123456789') + '@test.com',
    contact_mobile:
        '+33' + randomString(1, '67') + randomString(8, '0123456789'),
    contact_nom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Nom',
    contact_prenom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Prenom',
    credit_existants_duree_89tk42: 23,
    credit_existants_duree_dlynu: 50,
    credit_existants_list: ['dlynu', '89tk42'],
    credit_existants_mens_89tk42: 120,
    credit_existants_mens_dlynu: 100,
    credit_existants_type_89tk42: 'IMMO_LOCATIF', // AUTO, CONSO, IMMO_LOCATIF, IMMO_RES_PRINCIPALE, IMMO_RES_SECONDAIRE, PRET_ETUDIANT, TRAVAUX, TRESORERIE
    credit_existants_type_dlynu: 'IMMO_RES_PRINCIPALE', // AUTO, CONSO, IMMO_LOCATIF, IMMO_RES_PRINCIPALE, IMMO_RES_SECONDAIRE, PRET_ETUDIANT, TRAVAUX, TRESORERIE
    emp_proprio_last_2_ans: 'NON',
    emp_hab_devenir: 'GARDER', //GARDER, VENDRE_AVANT, VENDRE_APRES
    emp_hab_devenir_valeur: 157000,
    emp_nb_personnes_foyer: 2,
    emp_type_emprunteur: '2',
    emprunteurs_id_1: -1,
    emprunteurs_id_2: -1,
    emprunteurs_ordre_1: 1,
    emprunteurs_ordre_2: 1,
    emprunteurs_dossier_id_1: -1,
    emprunteurs_dossier_id_2: -1,
    emprunteurs_date_naissance_1: '30/12/1990',
    emprunteurs_date_naissance_1_validated: true,
    emprunteurs_date_naissance_2: '30/12/1990',
    emprunteurs_date_naissance_2_validated: true,
    emprunteurs_autre_rev_1: 'oui',
    emprunteurs_autre_rev_2: 'oui',
    emprunteurs_cat_emploi_1: 'PRIVE',
    emprunteurs_cat_emploi_2: 'PRIVE',
    emprunteurs_duree_salaire_1: 'MOINS_2_ANS',
    emprunteurs_duree_salaire_2: 'MOINS_2_ANS',
    emprunteurs_hab_actuelle: 'LOCATAIRE', //LOCATAIRE, PROPRIETAIRE, HEBERGE_GRATUITEMENT, LOGEMENT_FONCTION
    emprunteurs_hab_actuelle_localisation: {
        label: 'PARIS 05 ( 75005 )',
        name: 'PARIS 05',
        cp: '75005',
        cc: '75105',
    },

    emprunteurs_hab_pays: { label: 'France', value: 'FRA' }, // must be 3 char max
    emprunteurs_nb_mois_salaire_1: 12,
    emprunteurs_nb_mois_salaire_2: 13,
    emprunteurs_primes_1: 22,
    emprunteurs_primes_2: 1233,
    emprunteurs_rev_foncier_1: 250,
    emprunteurs_rev_foncier_2: 0,
    emprunteurs_rev_pensions_1: 0,
    emprunteurs_rev_pensions_2: 0,
    emprunteurs_rev_sociaux_1: 0,
    emprunteurs_rev_sociaux_2: 0,
    emprunteurs_salaire_net_mensuel_1: 3000,
    emprunteurs_salaire_net_mensuel_2: 2900,
    emprunteurs_type_emploi_1: 'PRIVE_CDI_CADRE',
    emprunteurs_type_emploi_2: 'PRIVE_CDI_NON_CADRE',
    finance_epargne_apres_apport: 10000,
    finance_apport: 10000,
    finance_duree_souhaite: 300,
    finance_revenu_fiscal_ref: 25000,
    files: [],
    pension_out: 12,
    prj_dispositif_fiscal: 'PINEL_6',
    prj_futur_loyer_estim: 22,
    prj_localisation_dep: { value: '12', label: 'Aveyron (12)' },
    prj_localisation_ville: {
        cc: '45234',
        cp: '45000',
        label: 'ORLEANS ( 45000 )',
        name: 'ORLEANS',
        ptz: 'A BIS',
    },
    prj_maturite: 'RECHERCHE', //RECHERCHE, TROUVE
    prj_montant_achat: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_terrain: 40000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_construction: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_frais_agence: 10000,
    prj_montant_frais_divers: 6000,
    prj_montant_travaux: 0,
    prj_type: 'LOGEMENT_NEUF', // LOGEMENT_NEUF, LOGEMENT_ANCIEN, TERRAIN_ET_CONSTRUCTION, TRAVAUX, RENEGOCIATION, ACHAT_SCPI
    prj_type_ptz: null, // LOGEMENT_NEUF | LOGEMENT_ANCIEN_PTZ | RACHAT_LOGEMENT_SOCIAL | LOGEMENT_ANCIEN_NON_PTZ
    prj_usage: 'RES_PRINCIPALE', //RES_PRINCIPALE, RES_SECONDAIRE, LOCATIF, PRO
    situation_habitation_actuelle_garder_location: 'NON',
    tech_city_code_preview: [],
    tech_solicitation: 'plusieursbanques',
    tech_type_action_depart: 'estimer',
    tech_already_initialized: false,
    tech_nb_document_pour_comparer_offre: 0,
    rgpd_accord: true,
    contact_mobile_validated: true,
    contact_mail_validated: true,
    /*
    tech_enr_dossier_status: 'SEND',
    tech_mobile_num_a_valider: false,
    tech_mobile_code_errone: false,
    resultat_affected_calendly: 'matthieu-c',
    resultat_affected_name: 'Shehrazade',
    tech_affichage_max_emp: 'OK',
    resultat_evaluation_calcul_emprunt_duree: 120,
    resultat_evaluation_calendly: 'blablalba',
    resultat_evaluation_max_empruntable: {
        mensualite: 50000,
        'montant-empruntable': 5000000,
        'montant-achat': 4000000,
        'montant-achat-ptz': 12577460,
        'montant-empruntable-ptz': 13545200,
        taux: 105.3434,
        'taux-avec-assurance': 140.5,
        duree: 20,
        ptz: { amortissement: 120, differe: 180, duree: 300, montant: 6600600 },
    },
    resultat_evaluation_alerts: [
        'Alerting 1 : bla bla bla 1',
        'Alerting 3 : bla bla bla 3',
        'Alerting 4 : bla bla bla 4',
    ] */
}

const scenarioTrouver = {
    autres_contacts_banque_solicite_1: 'BNP',
    autres_contacts_banque_solicite_2: ['sg', 'ca', 'bnp'],
    autres_contacts_courtier_solicite: '',
    contact_mail:
        randomString(8, 'abcdefghijklmnopqrstuvwxyz0123456789') + '@test.com',
    contact_mobile:
        '+33' + randomString(1, '67') + randomString(8, '0123456789'),
    contact_nom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Nom',
    contact_prenom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Prenom',
    credit_existants_duree_89tk42: 23,
    credit_existants_duree_dlynu: 50,
    credit_existants_list: ['dlynu', '89tk42'],
    credit_existants_mens_89tk42: 120,
    credit_existants_mens_dlynu: 100,
    credit_existants_type_89tk42: 'IMMO_LOCATIF', // AUTO, CONSO, IMMO_LOCATIF, IMMO_RES_PRINCIPALE, IMMO_RES_SECONDAIRE, PRET_ETUDIANT, TRAVAUX, TRESORERIE
    credit_existants_type_dlynu: 'IMMO_RES_PRINCIPALE', // AUTO, CONSO, IMMO_LOCATIF, IMMO_RES_PRINCIPALE, IMMO_RES_SECONDAIRE, PRET_ETUDIANT, TRAVAUX, TRESORERIE
    emp_proprio_last_2_ans: 'OUI',
    emp_hab_devenir: 'GARDER', //GARDER, VENDRE_AVANT, VENDRE_APRES
    emp_hab_devenir_valeur: 157000,
    emp_nb_personnes_foyer: 2,
    emp_type_emprunteur: '2',
    emprunteurs_id_1: -1,
    emprunteurs_id_2: -1,
    emprunteurs_ordre_1: 1,
    emprunteurs_ordre_2: 1,
    emprunteurs_dossier_id_1: -1,
    emprunteurs_dossier_id_2: -1,
    emprunteurs_date_naissance_1: '01/05/1995',
    emprunteurs_date_naissance_1_validated: true,
    emprunteurs_date_naissance_2: '16/07/1982',
    emprunteurs_date_naissance_2_validated: true,
    emprunteurs_autre_rev_1: 'oui',
    emprunteurs_autre_rev_2: 'oui',
    emprunteurs_cat_emploi_1: 'PRIVE',
    emprunteurs_cat_emploi_2: 'PRIVE',
    emprunteurs_duree_salaire_1: 'MOINS_2_ANS',
    emprunteurs_duree_salaire_2: 'MOINS_2_ANS',
    emprunteurs_hab_actuelle: 'LOCATAIRE', //LOCATAIRE, PROPRIETAIRE, HEBERGE_GRATUITEMENT, LOGEMENT_FONCTION
    emprunteurs_hab_actuelle_localisation: {
        label: 'PARIS 05 ( 75005 )',
        name: 'PARIS 05',
        cp: '75005',
        cc: '75105',
    },
    emprunteurs_hab_pays: { label: 'France', value: 'FRA' }, // must be 3 char max
    emprunteurs_nb_mois_salaire_1: 12,
    emprunteurs_nb_mois_salaire_2: 13,
    emprunteurs_primes_1: 22,
    emprunteurs_primes_2: 1233,
    emprunteurs_rev_foncier_1: 2500,
    emprunteurs_rev_foncier_2: 0,
    emprunteurs_rev_pensions_1: 0,
    emprunteurs_rev_pensions_2: 0,
    emprunteurs_rev_sociaux_1: 0,
    emprunteurs_rev_sociaux_2: 0,
    emprunteurs_salaire_net_mensuel_1: 5444,
    emprunteurs_salaire_net_mensuel_2: 4333,
    emprunteurs_type_emploi_1: 'PRIVE_CDI_NON_CADRE',
    emprunteurs_type_emploi_2: 'PRIVE_CDI_NON_CADRE',
    finance_epargne_apres_apport: 10000,
    finance_apport: 19000,
    finance_duree_souhaite: 240,
    files: [],
    pension_out: 12,
    //prj_dispositif_fiscal : "PINEL_6",
    prj_futur_loyer_estim: 22,
    prj_localisation_ville: {
        label: 'PARIS 03 ( 75003 )',
        name: 'PARIS 03',
        cp: '75003',
        cc: '75103',
    },
    prj_maturite: 'TROUVE', //RECHERCHE, TROUVE
    prj_montant_achat: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_terrain: 40000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_construction: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_frais_agence: 10000,
    prj_montant_frais_divers: 6000,
    prj_montant_travaux: 0,
    prj_type: 'LOGEMENT_NEUF', // LOGEMENT_NEUF, LOGEMENT_ANCIEN, TERRAIN_ET_CONSTRUCTION, TRAVAUX, RENEGOCIATION, ACHAT_SCPI
    prj_type_log: 'PSLA', // APPARTEMENT,IMMEUBLE,,MAISON_COLLECTIVE,,PSLA,,MAISON_INDIVIDUELLE,,AUTRE,
    prj_type_ptz: null, // LOGEMENT_NEUF | LOGEMENT_ANCIEN_PTZ | RACHAT_LOGEMENT_SOCIAL | LOGEMENT_ANCIEN_NON_PTZ
    prj_usage: 'RES_PRINCIPALE', //RES_PRINCIPALE, RES_SECONDAIRE, LOCATIF, PRO
    tech_city_code_preview: [],
    tech_solicitation: 'plusieursbanques',
    tech_type_action_depart: 'estimer',
    tech_already_initialized: false,
    tech_nb_document_pour_comparer_offre: 0,
    rgpd_accord: true,
    contact_mobile_validated: true,
    contact_mail_validated: true,
    situation_habitation_actuelle_garder_location: 'NON',
}

const scenarioRenego = {
    autres_contacts_banque_solicite_1: 'BNP',
    autres_contacts_banque_solicite_2: ['sg', 'ca', 'bnp'],
    autres_contacts_courtier_solicite: '',
    contact_mail:
        randomString(8, 'abcdefghijklmnopqrstuvwxyz0123456789') + '@test.com',
    contact_mobile:
        '+33' + randomString(1, '67') + randomString(8, '0123456789'),
    contact_nom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Nom',
    contact_prenom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Prenom',
    credit_existants_duree_89tk42: 23,
    credit_existants_duree_dlynu: 50,
    credit_existants_list: ['dlynu', '89tk42'],
    credit_existants_mens_89tk42: 120,
    credit_existants_mens_dlynu: 100,
    credit_existants_type_89tk42: 'IMMO_LOCATIF', // AUTO, CONSO, IMMO_LOCATIF, IMMO_RES_PRINCIPALE, IMMO_RES_SECONDAIRE, PRET_ETUDIANT, TRAVAUX, TRESORERIE
    credit_existants_type_dlynu: 'IMMO_RES_PRINCIPALE', // AUTO, CONSO, IMMO_LOCATIF, IMMO_RES_PRINCIPALE, IMMO_RES_SECONDAIRE, PRET_ETUDIANT, TRAVAUX, TRESORERIE
    emp_proprio_last_2_ans: 'OUI',
    emp_hab_devenir: 'GARDER', //GARDER, VENDRE_AVANT, VENDRE_APRES
    emp_hab_devenir_valeur: 157000,
    emp_nb_personnes_foyer: 2,
    emp_type_emprunteur: '2',
    emprunteurs_id_1: -1,
    emprunteurs_id_2: -1,
    emprunteurs_ordre_1: 1,
    emprunteurs_ordre_2: 1,
    emprunteurs_dossier_id_1: -1,
    emprunteurs_dossier_id_2: -1,
    emprunteurs_date_naissance_1: '02/12/1996',
    emprunteurs_date_naissance_1_validated: true,
    emprunteurs_date_naissance_2: '14/07/1988',
    emprunteurs_date_naissance_2_validated: true,
    emprunteurs_autre_rev_1: 'oui',
    emprunteurs_autre_rev_2: 'oui',
    emprunteurs_cat_emploi_1: 'PRIVE',
    emprunteurs_cat_emploi_2: 'PRIVE',
    emprunteurs_duree_salaire_1: 'MOINS_2_ANS',
    emprunteurs_duree_salaire_2: 'MOINS_2_ANS',
    emprunteurs_hab_actuelle: 'LOCATAIRE', //LOCATAIRE, PROPRIETAIRE, HEBERGE_GRATUITEMENT, LOGEMENT_FONCTION
    emprunteurs_hab_actuelle_localisation: {
        label: 'PARIS 05 ( 75005 )',
        name: 'PARIS 05',
        cp: '75005',
        cc: '75105',
    },
    emprunteurs_hab_pays: { label: 'France', value: 'FRA' }, // must be 3 char max
    emprunteurs_nb_mois_salaire_1: 12,
    emprunteurs_nb_mois_salaire_2: 13,
    emprunteurs_primes_1: 22,
    emprunteurs_primes_2: 1233,
    emprunteurs_rev_foncier_1: 2500,
    emprunteurs_rev_foncier_2: 0,
    emprunteurs_rev_pensions_1: 0,
    emprunteurs_rev_pensions_2: 0,
    emprunteurs_rev_sociaux_1: 0,
    emprunteurs_rev_sociaux_2: 0,
    emprunteurs_salaire_net_mensuel_1: 5444,
    emprunteurs_salaire_net_mensuel_2: 4333,
    emprunteurs_type_emploi_1: 'PRIVE_CDI_NON_CADRE',
    emprunteurs_type_emploi_2: 'PRIVE_CDI_NON_CADRE',
    finance_epargne_apres_apport: 0,
    finance_apport: 9000,
    finance_duree_souhaite: 240,
    files: [],
    pension_out: 12,
    prj_dispositif_fiscal: 'PINEL_6',
    prj_futur_loyer_estim: 22,
    prj_localisation_ville: {
        label: 'PARIS 03 ( 75003 )',
        name: 'PARIS 03',
        cp: '75003',
        cc: '75103',
    },
    prj_maturite: 'TROUVE', //RECHERCHE, TROUVE
    prj_montant_achat: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_terrain: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_construction: 400000, // apparement pour neuf, voir net_vendeur pour du ancien
    prj_montant_frais_agence: 10000,
    prj_montant_frais_divers: 6000,
    prj_montant_travaux: 0,
    prj_type: 'RENEGOCIATION', // LOGEMENT_NEUF, LOGEMENT_ANCIEN, TERRAIN_ET_CONSTRUCTION, TRAVAUX, RENEGOCIATION, ACHAT_SCPI
    prj_type_ptz: null, // LOGEMENT_NEUF | LOGEMENT_ANCIEN_PTZ | RACHAT_LOGEMENT_SOCIAL | LOGEMENT_ANCIEN_NON_PTZ
    prj_usage: 'RES_PRINCIPALE', //RES_PRINCIPALE, RES_SECONDAIRE, LOCATIF, PRO
    tech_city_code_preview: [],
    tech_solicitation: 'plusieursbanques',
    tech_type_action_depart: 'estimer',
    tech_already_initialized: false,
    tech_nb_document_pour_comparer_offre: 0,
    credit_renego_list: ['ABCD'],
    tech_credit_renego_target: 'ABCD',
    credit_renego_paliers_ABCD: [
        {
            mensualite: 400,
            duree: 36,
        },
        {
            mensualite: 350,
            duree: 48,
        },
    ],
    credit_renego_type_ABCD: 'pret_bancaire',
    credit_renego_capital_ABCD: 100000,
    credit_renego_preteur_ABCD: 'BNP',
    rgpd_accord: true,
    contact_mobile_validated: true,
    contact_mail_validated: true,
}

const scenarioDefault = {
    emprunteurs_hab_pays: { label: 'France', value: 'FRA' }, // must be 3 char max
    emprunteurs_hab_actuelle_localisation: {
        cc: '35238',
        cp: '35000',
        label: 'RENNES ( 35000 )',
        name: 'RENNES',
        ptz: 'B1',
    },
    contact_mail:
        randomString(8, 'abcdefghijklmnopqrstuvwxyz0123456789') + '@test.com',
    contact_mobile:
        '+33' + randomString(1, '67') + randomString(8, '0123456789'),
    contact_nom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Nom',
    contact_prenom: randomString(4, 'abcdefghijklmnopqrstuvwxyz') + 'Prenom',
    rgpd_accord: true,
    contact_mobile_validated: true,
    contact_mail_validated: true,

    emprunteurs_hab_actuelle: 'LOCATAIRE',
    finance_revenu_fiscal_ref: 15000,
    prj_maturite: 'RECHERCHE',
    prj_localisation_ville: {
        cc: '35238',
        cp: '35000',
        label: 'RENNES ( 35000 )',
        name: 'RENNES',
        ptz: 'B1',
    },
    prj_type: 'LOGEMENT_NEUF',
    prj_usage: 'RES_PRINCIPALE',
    emp_type_emprunteur: '1',
    emp_proprio_last_2_ans: 'NON',
    prj_montant_travaux: 0,
    prj_montant_achat: 150000,
    emp_nb_personnes_foyer: 2,
}

export { scenarioRecherche, scenarioTrouver, scenarioRenego, scenarioDefault }
